module.exports = __webpack_public_path__ + "static/media/29ADMSPC26.f9e5d97a.jpg";